import { useParams } from 'react-router-dom'
import EmbeddedMeetingNoteWrapper from './EmbeddedMeetingNote'

/** Main component for a note loaded as embedded note */
export default function EmbeddedNoteWrapper({ noteId }) {
  const { urlNoteId } = useParams()
  return <EmbeddedMeetingNoteWrapper embeddedNoteId={urlNoteId ?? noteId} key={urlNoteId ?? noteId} />
}
